import { getCommonStyle } from './styleCommon';
import { getCCIStyles } from './indicator/commoditychannelindex';
import { getHAStyles } from './indicator/horizontalannotation';
import { getIchimokuStyles } from './indicator/ichimokucloud';
import { getMFIStyles } from './indicator/moneyflowindex';
import { getPercentBStyles } from './indicator/percentb';
import { getPriceStyles } from './indicator/price';
import { getRSIStyles } from './indicator/rsi';
import { getStochasticsStyles } from './indicator/stochastics';
import { getUOStyles } from './indicator/ultimateoscillator';
import { getWPRStyles } from './indicator/williamspctr.js';

export function getIndicatorStyles() {

	return {
		adl: {
			color: '#D1009D',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		advancedecline: {
			color: '#49CF6B',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		avgtruerange: {
			color: '#007CEF',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		awesomeoscillator: {
			positive: {
				color: getCommonStyle('color.positive')
			},
			negative: {
				color: getCommonStyle('color.negative')
			}
		},
		bestworst: {
			best: {
				background: {
					color: 'rgba(17, 182, 0, 0.1)'
				},
				color: getCommonStyle('color.positive'),
				lineDash: '2,3'
			},
			worst: {
				background: {
					color: 'rgba(178, 0, 0, 0.1)'
				},
				color: getCommonStyle('color.negative'),
				lineDash: '2,3'
			},
			width: 1
		},
		bollinger: {
			background: {
				color: 'rgba(194, 235, 254, 0.15)'
			},
			color: 'rgba(136, 136, 136, 0.8)',
			lineDash: null,
			sma: {
				color: getCommonStyle('color.positive'),
				lineDash: null,
				width: getCommonStyle('line.width'),
				sessionBreak: getCommonStyle('sessionBreak')
			},
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		bollingerbandwidth: {
			color: '#CE9B3C',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		chaikins: {
			color: '#32868F',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		commoditychannelindex: getCCIStyles(),
		crs: {
			color: '#269843',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		defaults: {
			color: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		dividendyield: {
			color: '#0090FF',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		dmi: {
			adx: {
				color: '#0074E8',
				lineDash: '2,1',
				width: getCommonStyle('line.width'),
				sessionBreak: getCommonStyle('sessionBreak')
			},
			adxr: {
				color: 'darkorange',
				lineDash: null,
				width: getCommonStyle('line.width'),
				sessionBreak: getCommonStyle('sessionBreak')
			},
			negative: {
				color: 'blue',
				lineDash: null,
				width: getCommonStyle('line.width'),
				sessionBreak: getCommonStyle('sessionBreak')
			},
			positive: {
				color: '#FF5F20',
				lineDash: null,
				width: getCommonStyle('line.width'),
				sessionBreak: getCommonStyle('sessionBreak')
			},
			sessionBreak: getCommonStyle('sessionBreak')
		},
		ema: {
			color: '#D16905',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		gsrecommendation: {
			align: 'bottom',
			border: {
				left: {
					color: '#FFF'
				}
			},
			height: 7,
			margin: {
				bottom: 0,
				top: 0,
				hover: 0
			},
			notrated: {
				background: {
					color: 'rgba(0, 0, 0, 0.02)'
				}
			},
			positive: {
				background: {
					color: getCommonStyle('color.positive')
				}
			},
			negative: {
				background: {
					color: getCommonStyle('color.negative')
				}
			},
			neutral: {
				background: {
					color: getCommonStyle('color.neutral')
				}
			}
		},
		highlow: {
			min: {
				color: '#e70d18'
			},
			max: {
				color: '#077c07'
			},
			label: {
				glow: {
					color: null
				}
			}
		},
		horizontalannotation: getHAStyles(),
		ichimokucloud: getIchimokuStyles(),
		linearregression: {
			color: '#C05E00',
			lineDash: null,
			width: getCommonStyle('line.width')
		},
		macd: {
			color: '#046EE6',
			ema: {
				color: '#A82323',
				lineDash: null,
				width: getCommonStyle('line.width'),
				sessionBreak: getCommonStyle('sessionBreak')
			},
			lineDash: null,
			negative: {
				color: getCommonStyle('color.negative')
			},
			positive: {
				color: getCommonStyle('color.positive')
			},
			width: getCommonStyle('line.width'),
			zero: {
				color: '#888',
				lineDash: null,
				width: getCommonStyle('line.width')
			},
			sessionBreak: getCommonStyle('sessionBreak')
		},
		mae: {
			background: {
				color: 'rgba(194, 235, 254, 0.15)'
			},
			color: '#999',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		massindex: {
			color: '#672D8A',
			lineDash: null,
			setup: {
				color: '#EA7125',
				lineDash: null,
				width: 1,
				sessionBreak: getCommonStyle('sessionBreak')
			},
			trigger: {
				color: '#00A0DF',
				lineDash: null,
				width: 1,
				sessionBreak: getCommonStyle('sessionBreak')
			},
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		momentum: {
			background: {
				color: 'rgba(137, 56, 186, 0.2)'
			},
			color: '#8938BA',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		moneyflow: {
			color: 'darkred',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		moneyflowindex: getMFIStyles(),
		onbalancevolume: {
			color: '#E47600',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		nrv: {
			color: getCommonStyle('color.primary'),
			negative: {
				color: getCommonStyle('color.negative')
			},
			neutral: {
				color: '#999'
			},
			panelHeightRatio: getCommonStyle('panel.heightRatio'),
			positive: {
				color: getCommonStyle('color.positive')
			},
			yAxisPadding: {
				bottom: getCommonStyle('panel.yAxisPadding.bottom')
			}
		},
		perange: {
			color: '#2E9DE4',
			lineDash: null,
			low: {
				color: 'green',
				lineDash: null,
				width: getCommonStyle('line.width'),
				sessionBreak: getCommonStyle('sessionBreak')
			},
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		peratio: {
			color: '#E47600',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		percentb: getPercentBStyles(),
		previousclose: {
			color: '#555',
			label: {
				color: '#333',
				font: {
					family: getCommonStyle('font.family'),
					size: 11,
					weight: 'normal'
				},
				glow: {
					color: null
				}
			},
			lineDash: null,
			margin: {
				top: 0,
				bottom: 0
			},
			width: getCommonStyle('line.width')
		},
		price: getPriceStyles(),
		pricechannel: {
			background: {
				color: 'rgba(194, 235, 254, 0.15)'
			},
			color: '#888',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		proc: {
			color: 'green',
			lineDash: null,
			width: getCommonStyle('line.width'),
			zero: {
				color: '#000',
				lineDash: null,
				width: getCommonStyle('line.width')
			},
			sessionBreak: getCommonStyle('sessionBreak')
		},
		psar: {
			color: '#EA4D00',
			length: 4
		},
		revenues: {
			color: '#AB491F',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		rollingdividend: {
			color: '#26A42D',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		rollingeps: {
			color: '#216711',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		rsi: getRSIStyles(),
		sectorindustry: {
			color: '#EA4D00',
			lineDash: null,
			width: getCommonStyle('line.width')
		},
		sma: {
			color: '#0060FF',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		stochastics: getStochasticsStyles(),
		tsf: {
			color: '#0076C9',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		ultimateoscillator: getUOStyles(),
		updown: {
			color: '#72D6FB',
			lineDash: null,
			width: getCommonStyle('line.width')
		},
		updownratio: {
			color: '#2E8AAC',
			lineDash: null,
			width: getCommonStyle('line.width')
		},
		volume: {
			color: getCommonStyle('color.primary'),
			negative: {
				color: getCommonStyle('color.negative')
			},
			neutral: {
				color: '#999'
			},
			panelHeightRatio: getCommonStyle('panel.heightRatio'),
			positive: {
				color: getCommonStyle('color.positive')
			},
			radii: null,
			yAxisPadding: {
				bottom: getCommonStyle('panel.yAxisPadding.bottom')
			}
		},
		volumebyprice: {
			up: {
				color: 'rgba(34, 139, 34, 0.5)'
			},
			down: {
				color: 'rgba(178, 34, 34, 0.5)'
			}
		},
		vroc: {
			color: '#D56B03',
			lineDash: null,
			width: getCommonStyle('line.width'),
			zero: {
				color: '#333',
				width: 1,
				lineDash: null,
				sessionBreak: getCommonStyle('sessionBreak')
			},
			sessionBreak: getCommonStyle('sessionBreak')
		},
		vwap: {
			color: 'purple',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		williamspctr: getWPRStyles(),
		wma: {
			color: '#03907E',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		},
		yieldspread: {
			color: '#EA4D00',
			lineDash: null,
			width: getCommonStyle('line.width'),
			sessionBreak: getCommonStyle('sessionBreak')
		}
	};
}
